module.exports = __webpack_public_path__ + "img/dots_img.6a170e6.svg";